import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LegalPageState } from '@common/types/types';
import { BehaviorSubject } from 'rxjs';
import { CookiesConsentService } from 'src/services/cookies-consent.service';

@Component({
	selector: 'app-page',
	templateUrl: './page.component.html',
	styleUrls: ['./page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent {
	showTopBanner$ = new BehaviorSubject(true);
	showBottomBanner$ = new BehaviorSubject(true);
	LegalPageState = LegalPageState;
	@Input('showTopBanner')
	set _showTopBanner(showTopBanner: boolean) {
		this.showTopBanner$.next(showTopBanner);
	}
	@Input('showBottomBanner')
	set _showBottomBanner(showBottomBanner: boolean) {
		this.showBottomBanner$.next(showBottomBanner);
	}
	@Input() currentlegalPageState: LegalPageState;

	constructor(public cookiesConsentService: CookiesConsentService) {}
}
